export var ARROW_KEY_UP = 38;
export var ARROW_KEY_DOWN = 40;
export var ENTER_KEY = 13;
export var TAB_KEY = 9;